import { library } from '@fortawesome/fontawesome-svg-core';
import { faList, faSortAmountDown, faTh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { RowLayout } from '../../../../../../modules/common/layouts/rowLayout/RowLayout';
import { ListViewMode } from '../../../../user/user.store';

library.add(faSortAmountDown, faTh, faList);

interface IProjectDetailsImageListControlsProps {
  viewMode: ListViewMode;
  onViewModeChange(mode: ListViewMode): Promise<void>;
}

export const ProjectDetailsImageListControls = observer(
  (props: IProjectDetailsImageListControlsProps): ReactElement => (
    <RowLayout size='sm'>
      <div className='image-view-control'>
        <Button
          variant='outlined'
          color='primary'
          className='image-list-button'
          onClick={() => {
            void props.onViewModeChange(props.viewMode === ListViewMode.Tiles ? ListViewMode.List : ListViewMode.Tiles);
          }}
        >
          <FontAwesomeIcon icon={props.viewMode === ListViewMode.Tiles ? faList : faTh} />
        </Button>
      </div>
    </RowLayout>
  )
);
